// extracted by mini-css-extract-plugin
export default {"PDFContainer":"PDFContainer___TkUG1","pdfContainer":"PDFContainer___TkUG1"};